import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';

import TableBody from './tableBody';
import TableHead from './tableHead';

import { constants } from '../../helpers';
import useShiftSelected from '../../../../../utils/hooks/useShiftSelected';
import { MainContext } from '../../index';

const RefillTable = ({
  values,
  setValues,
  tasks,
  access,
  config,
  toggleView,
  setConfirmValues,
  toggleSuperDetail,
  isLoadingTable,
  modesFetch,
  servicesFetch,
}) => {
  const { t } = useTranslation();
  const [store] = useContext(MainContext);
  const { checked } = store;

  const tasksIds = useMemo(
    () => tasks
      ?.filter(
        (t) => t.status !== constants.STATUS_REJECTED
            && t.status !== constants.STATUS_COMPLETED
            && t.status !== constants.STATUS_IN_PROGRESS
            && t.status !== constants.STATUS_AWAITING,
      )
      .map((t) => t.id),
    [tasks],
  );

  const onChange = useShiftSelected(tasksIds, values);

  const onChangeCheck = (event, user) => {
    const nextValue = onChange(event, user.id);

    setValues(nextValue);
  };

  const onChangeCheckAll = (e) => {
    if (e.target.value === 'checkAll' && e.target.checked) {
      return setValues([
        ...tasks
          .filter(
            (item) => item.status !== constants.STATUS_REJECTED
              && item.status !== constants.STATUS_COMPLETED
              && item.status !== constants.STATUS_IN_PROGRESS
              && item.status !== constants.STATUS_AWAITING,
          )
          .map((item) => item.id),
      ]);
    }
    if (e.target.value === 'checkAll' && !e.target.checked) {
      return setValues([]);
    }
  };

  const copyToClipboard = (str) => {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

  const handleSelect = (props, type) => {
    const { key, title, id } = props;
    if (title === 'Copy to clipboard') {
      const orderIds = [
        ...new Set(
          tasks
            .filter((item) => checked.includes(Number(item.id)))
            .filter((item) => item.order_id)
            .map((item) => item.order_id),
        ),
      ];
      return copyToClipboard(orderIds);
    }

    switch (type) {
    case 'mass':
      setConfirmValues({
        id,
        key,
        title,
        actionType: type,
      });
      break;

    case 'single':
      if (title === t('ActionsList.Details')) {
        toggleView(id);
      } else if (title === t('ActionsList.Details for superadmin')) {
        toggleSuperDetail(id);
      } else if (title === t('ActionsList.Change status')) {
        setConfirmValues({
          id,
          key,
          title,
          actionType: type,
        });
      }

      break;

    default:
      break;
    }
  };

  return (
    <Table className="table-grey table__refill">
      <TableHead
        tasks={tasks}
        values={values}
        onChangeCheck={onChangeCheckAll}
        handleSelect={handleSelect}
        access={access}
        modesFetch={modesFetch}
        servicesFetch={servicesFetch}
        config={config}
      />
      <TableBody
        isLoading={isLoadingTable}
        tasks={tasks}
        values={values}
        onChangeCheck={onChangeCheck}
        handleSelect={handleSelect}
        access={access}
        config={config}
      />
    </Table>
  );
};

RefillTable.propTypes = {
  modesFetch: PropTypes.bool,
  servicesFetch: PropTypes.bool,
  key: PropTypes.string,
  title: PropTypes.string,
  id: PropTypes.string,
  values: PropTypes.array,
  setValues: PropTypes.func,
  isLoadingTable: PropTypes.bool,
  tasks: PropTypes.array,
  access: PropTypes.object,
  config: PropTypes.object,
  toggleView: PropTypes.func,
  setConfirmValues: PropTypes.func,
  toggleSuperDetail: PropTypes.func,
};

export default RefillTable;
